import { LOAD_CART, ADD_PRODUCT, REMOVE_PRODUCT } from "./actionTypes";

// Ação simples para carregar o carrinho
export const loadCart = (products) => ({
	type: LOAD_CART,
	payload: products,
});

// Thunk para adicionar produto com lógica para Pixel
export const addProduct = (product, triggerPixelEvent) => {
	return async (dispatch) => {
		// Dispara a ação ADD_PRODUCT primeiro
		dispatch({
			type: ADD_PRODUCT,
			payload: product,
		});

		// Verifique se triggerPixelEvent foi passado e está disponível
		if (typeof triggerPixelEvent === 'function') {
			try {
				// Disparar o evento personalizado do Meta Pixel para 'AddToCart'
				triggerPixelEvent('AddToCart', {
					value: product.price,
					currency: 'BRL',
					content_name: product.name,
					content_type: 'product', 
					content_ids: [product.id],
				});
				console.log('Evento AddToCart disparado com sucesso:', product);
			} catch (error) {
				console.error("Erro ao disparar o evento personalizado AddToCart: ", error);
			}
		} else {
			console.warn("triggerPixelEvent não está disponível.");
		}
	};
};

// Ação simples para remover produto
export const removeProduct = (product) => (dispatch) => {
	return dispatch({ type: REMOVE_PRODUCT, payload: product });
};
